import { render, staticRenderFns } from "./index.vue?vue&type=template&id=42c209aa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=42c209aa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c209aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42c209aa')) {
      api.createRecord('42c209aa', component.options)
    } else {
      api.reload('42c209aa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=42c209aa&scoped=true", function () {
      api.rerender('42c209aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/BjDialogList/index.vue"
export default component.exports